import NavBar from "./components/Navbar";
import Accordion from "./components/AccordionContainer";
import styled from "styled-components";

const AppContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 5vh;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  height: 100vh;
  width: 100vw;
`;

const ContentContainer = styled.div`
  width: 80%;
  max-width: 1000px;
  border-radius: 7px;
  /*background-color: white;*/
  ${(props) =>
    !props.user ? "" : "box-shadow: 2px 2px 2px rgba(0.2, 0.2, 0.2, 0.2)"};
`;

const user = null;
const MainScreenContainer = () => {
  return (
    <>
      <NavBar />
      <AppContainer>
        <ContentContainer user={user}>
          <Accordion />
        </ContentContainer>
      </AppContainer>
    </>
  );
};

export default MainScreenContainer;
